var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpandedMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.26677 10.5488C8.19591 10.6243 8.09982 10.6667 7.99962 10.6667C7.89943 10.6667 7.80333 10.6243 7.73247 10.5488L4.11026 6.68727C4.05758 6.63094 4.02173 6.55924 4.00722 6.48122C3.9927 6.4032 4.00019 6.32234 4.02872 6.24884C4.05725 6.17534 4.10555 6.1125 4.16754 6.06822C4.22952 6.02395 4.30242 6.00023 4.37703 6.00005L11.6215 6.00005C11.6963 5.99991 11.7695 6.02346 11.8317 6.06771C11.894 6.11196 11.9425 6.17493 11.9712 6.24863C11.9999 6.32232 12.0073 6.40343 11.9927 6.48166C11.9781 6.5599 11.942 6.63174 11.889 6.68808L8.26677 10.5488Z",
    fill: "#5B5C5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandedMenu);
export default __webpack_public_path__ + "static/media/ExpandedMenu.c2c7c5eb61273492eb5e795340219b14.svg";
export { ForwardRef as ReactComponent };